<template>
    <div @click="$emit('select')" class="ph3 ph4-ns flex items-center bt b--light-gray justify-between pointer" :class="{'bg-light-gray' : isSelected, 'hover-bg-near-white' : !isSelected}">
        <div style="padding-top:22px; padding-bottom:22px;">{{ categoryName }}</div>
        <div v-if="hasChild"><img class="arrowSize" src="@/assets/img/icon_forward_simple_yellow.svg"/></div>
        <div v-if="isSelected">
            <img src="@/assets/img/icon_check_black.svg"/>
        </div >
    </div>
</template>

<script>
export default {
    props: {
        categoryName: {
            type: String,
            required: true
        },
        hasChild: {
            type: Boolean,
            default: false
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.arrowSize {
    width: 10px;
}
</style>
